// eslint-disable-next-line import/prefer-default-export
export const timeNowInSeconds = Math.floor(Date.now() / 1000);
